import React from "react";
import * as S from "./styles";
import AddImage from "../../assets/addImage.png";
import { upload } from "@testing-library/user-event/dist/upload";

import { IoAddCircleOutline } from "react-icons/io5";
import { editPartnerImage, editPartnerLink, StateProps, uploadPresignedUrl } from "../../store";
import { useDispatch, useSelector } from "react-redux";

const AddPartnerImage = ({
  imageAlert,
  linkAlert,
  setImageAlert,
  setLinkAlert,
}: {
  imageAlert: boolean;
  linkAlert: boolean;
  setImageAlert: (alert: boolean) => void;
  setLinkAlert: (alert: boolean) => void;
}) => {
  const dispatch = useDispatch();
  const { formEtcs } = useSelector((state: StateProps) => state);

  const image = formEtcs.partnerImage;
  const link = formEtcs.partnerLink;

  const handleImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const fileSize = file.size / 1024 / 1024;

      if (fileSize > 1) {
        alert("이미지 크기는 1MB를 초과할 수 없습니다.");
        return;
      }

      const presignedUrl = await uploadPresignedUrl(file);

      dispatch(editPartnerImage({ partnerImage: presignedUrl }));
      setImageAlert(false);
    }
  };

  const handleDeleteImage = () => {
    dispatch(editPartnerImage({ partnerImage: "" }));
  };

  return (
    <S.Container alert={imageAlert || linkAlert}>
      {image ? (
        // <S.TitleHighlight image={image}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={image}
            alt="로고이미지"
            style={{
              display: "flex",
              width: "auto",
              height: "20px",
            }}
          />
          <S.DeleteButton onClick={handleDeleteImage}>×</S.DeleteButton>
          {/* </S.TitleHighlight> */}
          {/* </img> */}
        </div>
      ) : (
        <>
          <IoAddCircleOutline size={25} style={{ padding: 4 }} />

          {/* <S.PlusIcon src={AddImage} /> */}
          <S.HiddenInput
            type="file"
            accept="image/*"
            id="partnerImage"
            onChange={handleImageChange}
          />
          <S.Label htmlFor="partnerImage" />
        </>
      )}
      <S.LinkInput
        id="standard-basic"
        variant="standard"
        placeholder="https://monthler.kr"
        value={link}
        onChange={(e) => {
          dispatch(editPartnerLink({ partnerLink: e.target.value }));
          setLinkAlert(false);
        }}
      />
    </S.Container>
  );
};

export default AddPartnerImage;
